export const skusState = state => state.skus;

export const getLoadingSkus = state => skusState(state).loading;

export const getSku = state => skusState(state).sku;

export const getSkus = state => skusState(state).skus;

export const getResponseSkus = state => skusState(state).response;
